import React from 'react';
import { Calendar, Check, Clock } from 'lucide-react';

/**
 * Компонент секции ввода даты
 */
const DateInputSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Начальная дата */}
      <div>
        <label htmlFor="startDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Calendar className="w-4 h-4 mr-2 text-cyan-500" />
          Начальная дата
        </label>
        <input
          type="date"
          id="startDate"
          name="startDate"
          value={formData.startDate}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.startDate ? 'input-error' : ''}`}
        />
        {errors.startDate && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.startDate}
          </p>
        )}
      </div>

      {/* Настройки форматирования */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Clock className="w-4 h-4 mr-2 text-cyan-500" />
          Формат отображения даты
        </label>
        <div className="flex flex-col space-y-2">
          <div className="flex gap-4">
            <select
              id="returnFormat"
              name="returnFormat"
              value={formData.returnFormat}
              onChange={handleInputChange}
              className="form-select w-full"
            >
              <option value="short">Краткий (01.01.2023)</option>
              <option value="medium">Средний (1 янв 2023)</option>
              <option value="full">Полный (1 января 2023)</option>
            </select>
          </div>
          <div>
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                name="showWeekday"
                checked={formData.showWeekday}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                Показывать день недели
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateInputSection;